function getBasePath() {
  return (process.env.BASE_URL || '/').replace(/\/$/, '');
}

export function fixAssetPath(value: string) {
  if (!value || typeof value !== 'string') return value;
  const base = getBasePath();
  if (!base || base === '/') return value;
  if (/^(https?:)?\/\//i.test(value) || /^(data|blob|mailto|tel|javascript):/i.test(value)) return value;
  if (value.indexOf(base + '/') === 0) return value;
  if (/^\/(images|ClientResources|static)\//i.test(value)) return base + value;
  return value;
}

export function fixAssetPathsDeep<T>(input: T): T {
  if (typeof input === 'string') {
    return input.replace(/(src=["']|url\()\/(images|ClientResources|static)\//gi, function (match, prefix, folder) {
      return prefix + fixAssetPath('/' + folder + '/').replace(/\/$/, '/') ;
    }).replace(/"\/(images|ClientResources|static)\//gi, function (match) {
      return '"' + fixAssetPath(match.slice(1));
    }).replace(/'\/(images|ClientResources|static)\//gi, function (match) {
      return "'" + fixAssetPath(match.slice(1));
    }) as any;
  }
  if (Array.isArray(input)) return input.map(item => fixAssetPathsDeep(item)) as any;
  if (input && typeof input === 'object') {
    Object.keys(input as any).forEach((key) => {
      (input as any)[key] = fixAssetPathsDeep((input as any)[key]);
    });
  }
  return input;
}

export function installMobileAssetPathFix() {
  const base = getBasePath();
  if (!base || base === '/' || VuePrototypeUserAgent() !== 'mobile') return;

  const fixImage = (img: HTMLImageElement) => {
    const src = img.getAttribute('src');
    const fixed = fixAssetPath(src || '');
    if (src && fixed !== src) img.setAttribute('src', fixed);
  };

  const fixAll = (root: ParentNode) => {
    root.querySelectorAll('img').forEach((img) => fixImage(img as HTMLImageElement));
  };

  document.addEventListener('error', (event) => {
    const target = event.target as HTMLElement;
    if (target && target.tagName === 'IMG') fixImage(target as HTMLImageElement);
  }, true);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.tagName === 'IMG') fixImage(node as HTMLImageElement);
        fixAll(node);
      });
      if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
        fixImage(mutation.target);
      }
    });
  });

  const start = () => {
    fixAll(document);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src']
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}

function VuePrototypeUserAgent() {
  return window.innerWidth < 992 ? 'mobile' : 'pc';
}
